import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from "@angular/forms";
import { HttpClient, HttpEvent, HttpEventType } from '@angular/common/http';
import { Router, ActivatedRoute } from '@angular/router';
import { NgxSpinnerService } from "ngx-spinner";
import Swal from 'sweetalert2';

import { LoginService } from '../../services/login.service';
import { DashboardService } from '../../services/dashboard.service';

@Component({
  selector: 'app-edit',
  templateUrl: './edit.component.html',
  styleUrls: ['./edit.component.css']
})
export class EditComponent implements OnInit {

  public session_data: any = {};
  public err: any = {};
  public result: any = {};
  public data: any = {};
  public form: any = {};
  public projects = [];
  public checked_sm: any = {all: true, twitter: false, facebook: false, instagram: false, web: false, youtube: false, reviews: false, others: false};
  public txt_projects: any = [];
  public channels: any = [];
  public assign_projects = [];
  public id: string;

  constructor(private login: LoginService, private router: Router, public fb: FormBuilder,
    private spinner: NgxSpinnerService, private service: DashboardService, private activeRouter: ActivatedRoute) {
    this.id = this.activeRouter.snapshot.paramMap.get('id');//id from url
    this.session_data.id = login.get_session_data('ieye_session_id');
    this.service.setTitle('Edit User | 24ieye');
    if(this.session_data.id == 2){
        this.router.navigate(['projects']);
    }
    this.form = this.fb.group({
      str_first_name: [''],
      str_company: [''],
      str_email: [''],
      txt_projects: ['']
    });
  }

  ngOnInit(): void {
	this.get_data();
	setTimeout(() => {
        this.get_project_data();
    }, 500); 
  }

  public async get_project_data() {
	var formData: any = new FormData();
    formData.append("user_id", this.session_data.id);
	this.result = await this.service.form_actions(formData, 'projects'); 
	if (this.result.status == false) {
      
    } else {
      this.projects = this.result.data;
      this.projects.forEach((project, index) => {
		  if(this.txt_projects.includes(project.id)){
				this.assign_projects[project.id] = new Array();
				if(this.channels.length == 0){
					this.assign_projects[project.id] = {selected: false, id: project.id, name: project.name, all: true, twitter: false, facebook: false, instagram: false, web: false, youtube: false, reviews: false, others: false}
				} else {
					this.assign_projects[project.id] = this.channels[project.id];
				}
		  } else {
				this.assign_projects[project.id] = new Array();
				this.assign_projects[project.id] = {selected: false, id: project.id, name: project.name, all: true, twitter: false, facebook: false, instagram: false, web: false, youtube: false, reviews: false, others: false}
		  }
      });
	  
    }
  }

  public async get_data() {
    this.spinner.show();
    var formData: any = new FormData();
    formData.append("id", this.id);
    this.result = await this.service.form_actions(formData, 'get_data');
    this.spinner.hide();
    if (this.result == 'error') {
      Swal.fire('Alert!', 'Something went wrong! Please try again later.', 'error');
      return false;
    }
    if (this.result.error == false) {

    } else {
      this.data = this.result.data;
      this.checked_sm = this.data.channels;
	  this.txt_projects = this.data.projects;
	  this.channels = this.data.channels;
      this.form = this.fb.group({
        str_first_name: [this.data.first_name],
        str_company: [this.data.company],
        str_email: [this.data.email],
        //txt_projects: [this.data.projects],
        id: [this.data.id]
      });
    }
  }

  public async edit_user() {
    this.spinner.show();
    var formData: any = new FormData();
    formData.append("id", this.form.value.id);
    formData.append("str_first_name", this.form.value.str_first_name);
    formData.append("str_company", this.form.value.str_company);
    formData.append("str_email", this.form.value.str_email);
    formData.append("txt_projects", JSON.stringify(this.txt_projects)); 
    formData.append("txt_channels", JSON.stringify(this.assign_projects));
    this.result = await this.service.form_actions(formData, 'edit_user');
    this.spinner.hide();
    if (this.result == 'error') {
      Swal.fire('Alert!', 'Something went wrong! Please try again later.', 'error');
      return false;
    }
    if (this.result.status == false) {
      if (this.result.code == 202) {
        this.err = {};
        Swal.fire('Alert!', this.result.message, 'error');
      } else {
        this.err = this.result.errors;
      }
    } else {
      Swal.fire({ icon: 'success', title: this.result.message, showConfirmButton: false, timer: 1500 })
      setTimeout(() => {
        this.router.navigate(['users']);
      }, 2000);
    }
  }
  
  public select_project(e){  
	var project_id = e.target.value;
	if(e.target.checked){
		this.txt_projects.push(project_id);
		this.assign_projects[project_id].selected = true;
	} else {
		this.removeProjectFromArray(project_id);
		this.assign_projects[project_id].selected = false;
		this.assign_projects[project_id].all = true;
		this.assign_projects[project_id].twitter = this.assign_projects[project_id].facebook = this.assign_projects[project_id].web = this.assign_projects[project_id].instagram = this.assign_projects[project_id].youtube = this.assign_projects[project_id].reviews = this.assign_projects[project_id].others = false;
	}
	console.log(this.assign_projects); 
  }
  
  public sm_checkbox_event(e){  
	var project_id = e.target.id; 
	var value = e.target.value;
	
	if('all' == e.target.value && !this.assign_projects[project_id].twitter && !this.assign_projects[project_id].facebook && !this.assign_projects[project_id].web && !this.assign_projects[project_id].instagram && !this.assign_projects[project_id].youtube && !this.assign_projects[project_id].reviews && !this.assign_projects[project_id].others)
        return false;
	
      if('all' == e.target.value){
          this.assign_projects[project_id].twitter = this.assign_projects[project_id].facebook = this.assign_projects[project_id].web = this.assign_projects[project_id].instagram = this.assign_projects[project_id].youtube = this.assign_projects[project_id].reviews = this.assign_projects[project_id].others = false;
          this.assign_projects[project_id].all = e.target.checked ? true : false;
      }
      if('twitter' == e.target.value)
        this.assign_projects[project_id].twitter = e.target.checked ? true : false;
      if('facebook' == e.target.value)
        this.assign_projects[project_id].facebook = e.target.checked ? true : false;
      if('web' == e.target.value)
        this.assign_projects[project_id].web = e.target.checked ? true : false;
      if('instagram' == e.target.value)
        this.assign_projects[project_id].instagram = e.target.checked ? true : false;
      if('youtube' == e.target.value)
        this.assign_projects[project_id].youtube = e.target.checked ? true : false;
      if('reviews' == e.target.value)
        this.assign_projects[project_id].reviews = e.target.checked ? true : false;
      if('others' == e.target.value)
        this.assign_projects[project_id].others = e.target.checked ? true : false;
        
      if(this.assign_projects[project_id].twitter || this.assign_projects[project_id].facebook || this.assign_projects[project_id].web || this.assign_projects[project_id].instagram || this.assign_projects[project_id].youtube || this.assign_projects[project_id].reviews || this.assign_projects[project_id].others)
        this.assign_projects[project_id].all = false;
	
		if(!this.assign_projects[project_id].twitter && !this.assign_projects[project_id].facebook && !this.assign_projects[project_id].web && !this.assign_projects[project_id].instagram && !this.assign_projects[project_id].youtube && !this.assign_projects[project_id].reviews && !this.assign_projects[project_id].others)
			this.assign_projects[project_id].all = true;

  }
  
  removeProjectFromArray(value){
    const index: number = this.txt_projects.indexOf(value);
    this.txt_projects.splice(index, 1);
  }

}
